import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Everything beyond confirmMessage is optional so the many `{ confirmMessage }` callers keep the default
 * "Please Confirm" / Cancel / Confirm dialog. `paragraphs` replaces confirmMessage when a body needs more
 * than one paragraph.
 */
export interface DynamicConfirmModalData {
  confirmMessage?: string;
  paragraphs?: string[];
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** A notice rather than a question: only the confirm button shows. */
  hideCancel?: boolean;
}

@Component({
    selector: 'app-dynamic-confirm-modal',
    templateUrl: './dynamic-confirm-modal.component.html',
    styleUrls: ['./dynamic-confirm-modal.component.css'],
    standalone: false
})
export class DynamicConfirmModalComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DynamicConfirmModalData) { }

  get title(): string {
    return this.data.title ?? 'Please Confirm';
  }

  get paragraphs(): string[] {
    return this.data.paragraphs ?? [this.data.confirmMessage];
  }

  get confirmLabel(): string {
    return this.data.confirmLabel ?? 'Confirm';
  }

  get cancelLabel(): string {
    return this.data.cancelLabel ?? 'Cancel';
  }

}
